// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-user-dashboards-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-user-dashboards-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-dashboards-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-user-dashboards-container{
        width: 96%;
        height: 94%;
        padding: 0px;
        border-radius: 4px;
        position: relative;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    }
    .customer-user-dashboards-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-user-dashboards-header-container h2{
        padding-left: 32px;
        font-size: 22px;
        font-weight: 400;
        color: rgb(49, 49, 49);
    }
    .customer-user-dashboards-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-user-dashboards-server-url-select{
        margin: 0px;
        padding: 4px 16px;
        margin-right: 10px;
        font-size: 14px;
        border: none;
        outline: none;
        border-radius: 4px;
        background-color: rgb(222, 229, 233);
    }
    .customer-user-add-new-dashboard-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 2px 4px;
    }
    .customer-user-add-new-dashboard-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-add-new-dashboard-button img{
        height: 30px;
    }
    .customer-user-refresh-dashboards-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 5px 7px;
    }
    .customer-user-refresh-dashboards-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-refresh-dashboards-button img{
        height: 25px;
    }
    .customer-user-dashboards-table-container{
        overflow-y: auto;
        height: 70vh;
    }
    .customer-user-dashboards-table-container::-webkit-scrollbar{
        width: 4px;
    }
    .customer-user-dashboards-table-container::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .customer-user-dashboards-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: none;
    }
    #customer-user-dashboards-table-header-row{
        color: black;
        background-color: transparent;
    }
    #customer-user-dashboards-table-header-row th{
        font-weight: 600;
    }
    #customer-user-dashboards-table-header-row th:first-child{
        padding-left: 32px;
    }
    .customer-user-dashboards-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-user-dashboards-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
    .customer-user-dashboards-table th, .customer-user-dashboards-table td{
        white-space: nowrap;
        text-align: left;
        padding: 8px 5px;
    }
    .customer-user-dashboards-table td{
        font-size: 12px;
    }
    .customer-user-dashboards-table td:first-child{
        padding-left: 32px;
    }
    .customer-user-dashboards-table td:nth-child(3){
        font-size: 12px;
        padding-right: 100px;
    }
    .customer-user-dashboards-table td:last-child .controls-container{
        margin-right: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .customer-user-dashboards-table-manage-assigned-customers-icon,
    .customer-user-dashboards-table-delete-icon{
        height: 20px;
        border-radius: 50%;
    }
    .customer-user-dashboards-footer-container{
        position: absolute;
        width: 100%;
        bottom: 0;
        margin: 0px;
        padding: 10px 32px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-top: 1px solid rgb(224, 224, 224);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container{
        display: flex;
        align-items: center;
        margin-right: 20px;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container p{
        margin: 0px;
        font-size: 14px;
        color: rgb(83, 83, 83);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container select{
        margin: 0px 6px;
        padding: 6px 12px;
        border-radius: 4px;
        background-color: transparent;
        border: 1px solid rgb(214, 214, 214);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-info-container p{
        margin: 0px;
        font-size: 14px;
        color: rgb(83, 83, 83);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container{
        padding: 0px 20px;
        padding-bottom: 4px;
        display: flex;
        align-items: center;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container p{
        margin: 0px 12px;
        cursor: pointer;
        color: rgb(119, 119, 119);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page{
        font-size: 20px;
        margin-bottom: 2px;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page{
        font-size: 15px;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page.inactive{
        color: rgb(214, 214, 214);
        cursor: default;
    }
}
@media screen and (max-width:949px){
    .customer-user-dashboards-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-user-dashboards-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-user-dashboards-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-user-dashboards-container{
        height: 90vh;
        width: 100vw;
        box-shadow: none;
        overflow: auto;
        position: relative;
    }
    .customer-user-dashboards-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-user-dashboards-header-container h2{
        margin-left: 15px;
        font-size: 16px;
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .customer-user-dashboards-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-user-dashboards-server-url-select{
        margin: 0px;
        padding: 4px 10px;
        margin-right: 10px;
        font-size: 12px;
        width: 40vw;
        border: none;
        outline: none;
        border-radius: 4px;
        background-color: rgb(222, 229, 233);
    }
    .customer-user-add-new-dashboard-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 2px 4px;
    }
    .customer-user-add-new-dashboard-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-add-new-dashboard-button img{
        height: 30px;
    }
    .customer-user-refresh-dashboards-button{
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 4px 7px;
        padding-top: 6px;
        margin-top: 4px;
        margin-right: 10px;
        background-color: transparent;
    }
    .customer-user-refresh-dashboards-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-user-refresh-dashboards-button img{
        height: 20px;
    }
    .customer-user-dashboards-table-container{
        overflow: auto;
        max-height: 80vh;
        box-sizing: border-box;
    }
    .customer-user-dashboards-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: none;
    }
    #customer-user-dashboards-table-header-row{
        color: black;
        background-color: transparent;
    }
    #customer-user-dashboards-table-header-row th{
        font-size: 14px;
        font-weight: 600;
    }
    #customer-user-dashboards-table-header-row th:first-child{
        padding-left: 32px;
    }
    .customer-user-dashboards-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-user-dashboards-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
    .customer-user-dashboards-table th, .customer-user-dashboards-table td{
        white-space: nowrap;
        text-align: left;
        padding: 8px 5px;
        display: none;
    }
    .customer-user-dashboards-table th:first-child,
    .customer-user-dashboards-table td:first-child,
    .customer-user-dashboards-table th:nth-child(2),
    .customer-user-dashboards-table td:nth-child(2){
        display: table-cell;
    }
    .customer-user-dashboards-table td{
        font-size: 12px;
    }
    .customer-user-dashboards-table td:first-child{
        padding-left: 32px;
    }
    .customer-user-dashboards-footer-container{
        position: absolute;
        width: 100%;
        bottom: 0;
        margin: 0px;
        padding: 10px 32px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-top: 1px solid rgb(224, 224, 224);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container{
        display: none;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-info-container p{
        margin: 0px;
        font-size: 14px;
        color: rgb(83, 83, 83);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container{
        padding: 0px 20px;
        padding-bottom: 4px;
        display: flex;
        align-items: center;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container p{
        margin: 0px 12px;
        cursor: pointer;
        color: rgb(119, 119, 119);
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page{
        font-size: 20px;
        margin-bottom: 2px;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page{
        font-size: 15px;
    }
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page.inactive,
    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page.inactive{
        color: rgb(214, 214, 214);
        cursor: default;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerUserStyles/Dashboards/Dashboards.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,sCAAsC;IAC1C;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;;QAEI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,wCAAwC;IAC5C;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;QAC7B,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;IACA;;QAEI,eAAe;QACf,kBAAkB;IACtB;IACA;;QAEI,eAAe;IACnB;IACA;;;;QAII,yBAAyB;QACzB,eAAe;IACnB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,6BAA6B;IACjC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;IACA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;IACjB;IACA;;;;QAII,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,wCAAwC;IAC5C;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;IACA;;QAEI,eAAe;QACf,kBAAkB;IACtB;IACA;;QAEI,eAAe;IACnB;IACA;;;;QAII,yBAAyB;QACzB,eAAe;IACnB;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-user-dashboards-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-user-dashboards-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-dashboards-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-user-dashboards-container{\r\n        width: 96%;\r\n        height: 94%;\r\n        padding: 0px;\r\n        border-radius: 4px;\r\n        position: relative;\r\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .customer-user-dashboards-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-header-container h2{\r\n        padding-left: 32px;\r\n        font-size: 22px;\r\n        font-weight: 400;\r\n        color: rgb(49, 49, 49);\r\n    }\r\n    .customer-user-dashboards-header-controls{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-server-url-select{\r\n        margin: 0px;\r\n        padding: 4px 16px;\r\n        margin-right: 10px;\r\n        font-size: 14px;\r\n        border: none;\r\n        outline: none;\r\n        border-radius: 4px;\r\n        background-color: rgb(222, 229, 233);\r\n    }\r\n    .customer-user-add-new-dashboard-button{\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 2px 4px;\r\n    }\r\n    .customer-user-add-new-dashboard-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-add-new-dashboard-button img{\r\n        height: 30px;\r\n    }\r\n    .customer-user-refresh-dashboards-button{\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 5px 7px;\r\n    }\r\n    .customer-user-refresh-dashboards-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-refresh-dashboards-button img{\r\n        height: 25px;\r\n    }\r\n    .customer-user-dashboards-table-container{\r\n        overflow-y: auto;\r\n        height: 70vh;\r\n    }\r\n    .customer-user-dashboards-table-container::-webkit-scrollbar{\r\n        width: 4px;\r\n    }\r\n    .customer-user-dashboards-table-container::-webkit-scrollbar-thumb{\r\n        border-radius: 5px;\r\n        background-color: rgba(0, 0, 0, 0.3);\r\n    }\r\n    .customer-user-dashboards-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: none;\r\n    }\r\n    #customer-user-dashboards-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    #customer-user-dashboards-table-header-row th{\r\n        font-weight: 600;\r\n    }\r\n    #customer-user-dashboards-table-header-row th:first-child{\r\n        padding-left: 32px;\r\n    }\r\n    .customer-user-dashboards-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-user-dashboards-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n    .customer-user-dashboards-table th, .customer-user-dashboards-table td{\r\n        white-space: nowrap;\r\n        text-align: left;\r\n        padding: 8px 5px;\r\n    }\r\n    .customer-user-dashboards-table td{\r\n        font-size: 12px;\r\n    }\r\n    .customer-user-dashboards-table td:first-child{\r\n        padding-left: 32px;\r\n    }\r\n    .customer-user-dashboards-table td:nth-child(3){\r\n        font-size: 12px;\r\n        padding-right: 100px;\r\n    }\r\n    .customer-user-dashboards-table td:last-child .controls-container{\r\n        margin-right: 64px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n    .customer-user-dashboards-table-manage-assigned-customers-icon,\r\n    .customer-user-dashboards-table-delete-icon{\r\n        height: 20px;\r\n        border-radius: 50%;\r\n    }\r\n    .customer-user-dashboards-footer-container{\r\n        position: absolute;\r\n        width: 100%;\r\n        bottom: 0;\r\n        margin: 0px;\r\n        padding: 10px 32px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        border-top: 1px solid rgb(224, 224, 224);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container{\r\n        display: flex;\r\n        align-items: center;\r\n        margin-right: 20px;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container p{\r\n        margin: 0px;\r\n        font-size: 14px;\r\n        color: rgb(83, 83, 83);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container select{\r\n        margin: 0px 6px;\r\n        padding: 6px 12px;\r\n        border-radius: 4px;\r\n        background-color: transparent;\r\n        border: 1px solid rgb(214, 214, 214);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-info-container p{\r\n        margin: 0px;\r\n        font-size: 14px;\r\n        color: rgb(83, 83, 83);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container{\r\n        padding: 0px 20px;\r\n        padding-bottom: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container p{\r\n        margin: 0px 12px;\r\n        cursor: pointer;\r\n        color: rgb(119, 119, 119);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page{\r\n        font-size: 20px;\r\n        margin-bottom: 2px;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page{\r\n        font-size: 15px;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page.inactive{\r\n        color: rgb(214, 214, 214);\r\n        cursor: default;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-user-dashboards-page{\r\n        margin: 0px;\r\n        padding: 0px;\r\n        height: 100vh;\r\n        box-sizing: border-box;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .customer-user-dashboards-page-layout{\r\n        height: 90%;\r\n        box-sizing: border-box;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n    }\r\n    .customer-user-dashboards-parent-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .customer-user-dashboards-container{\r\n        height: 90vh;\r\n        width: 100vw;\r\n        box-shadow: none;\r\n        overflow: auto;\r\n        position: relative;\r\n    }\r\n    .customer-user-dashboards-header-container{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-header-container h2{\r\n        margin-left: 15px;\r\n        font-size: 16px;\r\n        font-weight: lighter;\r\n        color: rgb(90, 90, 90);\r\n    }\r\n    .customer-user-dashboards-header-controls{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-server-url-select{\r\n        margin: 0px;\r\n        padding: 4px 10px;\r\n        margin-right: 10px;\r\n        font-size: 12px;\r\n        width: 40vw;\r\n        border: none;\r\n        outline: none;\r\n        border-radius: 4px;\r\n        background-color: rgb(222, 229, 233);\r\n    }\r\n    .customer-user-add-new-dashboard-button{\r\n        background-color: transparent;\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 2px 4px;\r\n    }\r\n    .customer-user-add-new-dashboard-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-add-new-dashboard-button img{\r\n        height: 30px;\r\n    }\r\n    .customer-user-refresh-dashboards-button{\r\n        border: none;\r\n        cursor: pointer;\r\n        border-radius: 50%;\r\n        padding: 4px 7px;\r\n        padding-top: 6px;\r\n        margin-top: 4px;\r\n        margin-right: 10px;\r\n        background-color: transparent;\r\n    }\r\n    .customer-user-refresh-dashboards-button:hover{\r\n        background-color: rgb(214, 214, 214);\r\n    }\r\n    .customer-user-refresh-dashboards-button img{\r\n        height: 20px;\r\n    }\r\n    .customer-user-dashboards-table-container{\r\n        overflow: auto;\r\n        max-height: 80vh;\r\n        box-sizing: border-box;\r\n    }\r\n    .customer-user-dashboards-table{\r\n        width: 100%;\r\n        border-collapse: collapse;\r\n        box-shadow: none;\r\n    }\r\n    #customer-user-dashboards-table-header-row{\r\n        color: black;\r\n        background-color: transparent;\r\n    }\r\n    #customer-user-dashboards-table-header-row th{\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n    }\r\n    #customer-user-dashboards-table-header-row th:first-child{\r\n        padding-left: 32px;\r\n    }\r\n    .customer-user-dashboards-table tr:nth-child(even){\r\n        cursor: pointer;\r\n        background-color: rgb(242, 242, 242);\r\n    }\r\n    .customer-user-dashboards-table tr:nth-child(odd){\r\n        cursor: pointer;\r\n        background-color: rgba(206, 206, 206, 0.952);\r\n    }\r\n    .customer-user-dashboards-table th, .customer-user-dashboards-table td{\r\n        white-space: nowrap;\r\n        text-align: left;\r\n        padding: 8px 5px;\r\n        display: none;\r\n    }\r\n    .customer-user-dashboards-table th:first-child,\r\n    .customer-user-dashboards-table td:first-child,\r\n    .customer-user-dashboards-table th:nth-child(2),\r\n    .customer-user-dashboards-table td:nth-child(2){\r\n        display: table-cell;\r\n    }\r\n    .customer-user-dashboards-table td{\r\n        font-size: 12px;\r\n    }\r\n    .customer-user-dashboards-table td:first-child{\r\n        padding-left: 32px;\r\n    }\r\n    .customer-user-dashboards-footer-container{\r\n        position: absolute;\r\n        width: 100%;\r\n        bottom: 0;\r\n        margin: 0px;\r\n        padding: 10px 32px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        border-top: 1px solid rgb(224, 224, 224);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-limit-container{\r\n        display: none;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-info-container p{\r\n        margin: 0px;\r\n        font-size: 14px;\r\n        color: rgb(83, 83, 83);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container{\r\n        padding: 0px 20px;\r\n        padding-bottom: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container p{\r\n        margin: 0px 12px;\r\n        cursor: pointer;\r\n        color: rgb(119, 119, 119);\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page{\r\n        font-size: 20px;\r\n        margin-bottom: 2px;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page{\r\n        font-size: 15px;\r\n    }\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .first-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .previous-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .next-page.inactive,\r\n    .customer-user-dashboards-footer-container .customer-user-dashboards-page-navigator-container .last-page.inactive{\r\n        color: rgb(214, 214, 214);\r\n        cursor: default;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
